import React from 'react';

import OverlayableStyled from './Overlayable.styles';

export type OverlayableProps = {
  base: React.ReactNode,
  sizeToParent?: boolean;
};

// Element that sizes itself according to base and overlays the children
export const Overlayable: React.FC<OverlayableProps> = ({ base, sizeToParent, children }) => (
  <OverlayableStyled sizeToParent={sizeToParent === true}>
    {base}
    <div className='OverlayContainer'>
      {children}
    </div>
  </OverlayableStyled>
);

export default Overlayable;